import { defineMobileFormWindow } from "@app/overlay";
import { WsInvActsFilterForm, type WsInvActsFilterFormProps } from "./components/WsInvActsFilter/WsInvActsFilterForm";

/** Реестр overlay-окон списка АИ УП. */
export const wsInvActsListWindows = {
    filter: defineMobileFormWindow<WsInvActsFilterFormProps>({
        key: "workshop.invActs.filter",
        title: "Фильтр АИ УП",
        component: WsInvActsFilterForm,
    }),
};
